export default __webpack_public_path__ + "static/logo_en-aff3ef7e9dd3440a33343a2b203661d3.png";